import store from "@frameworks/web/redux/store";
import { CONTRIBUTION, CONTRIBUTION_ERROR, CONTRIBUTION_HIDE_ERROR, CONTRIBUTION_START_LOADER, CONTRIBUTION_STOP_LOADER, } from "../interface/IContribution";
class ContributionActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getContributionDetails(data) {
        this.dispatch({
            type: CONTRIBUTION,
            payload: { data },
        });
    }
    setError(payload) {
        this.dispatch({
            type: CONTRIBUTION_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError() {
        this.dispatch({
            type: CONTRIBUTION_HIDE_ERROR,
        });
    }
    startLoader() {
        this.dispatch({
            type: CONTRIBUTION_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: CONTRIBUTION_STOP_LOADER,
        });
    }
}
export default ContributionActions;
